import React from 'react';
import Hero from '../components/Hero';
import AboutUs from '../components/AboutUs';
import Services from '../components/Services';
import Testimonials from '../components/Testimonials';
import FAQ from '../components/FAQ';

export default function Home({ onBook }) {
  return (
    <main>
      <Hero onBook={onBook} />
      <AboutUs />
      <Services onBook={onBook} />
      <Testimonials />
      <FAQ />
    </main>
  );
}